import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import { toast } from "react-toastify";
import Cookies from "js-cookie";
import {Layers} from 'lucide-react'

const Sidebar = ({ selectedTopic, setSelectedTopic , selectedDisplayName, setSelectedDisplayName }) => {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(true);
  const [isMobile, setIsMobile] = useState(false);
  const storedProducts = localStorage.getItem('userProducts');
  const user = Cookies.get("customerName");
  const parsedProducts = storedProducts ? JSON.parse(storedProducts) : [];


  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        setIsMobile(true);
        setIsOpen(false);
      } else {
        setIsMobile(false);
        setIsOpen(true);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (isMobile && isOpen && !event.target.closest(".sidebar")) {
        setIsOpen(false);
      }
    };
    document.addEventListener("click", handleOutsideClick);

    return () => document.removeEventListener("click", handleOutsideClick);
  }, [isMobile, isOpen]);

  const toggleSidebar = () => setIsOpen(!isOpen);

  const logoutFunction = () => {
    Cookies.remove("token");
    Cookies.remove("customerName");
    localStorage.removeItem("userProducts");
    toast.info("You have been logged out.");
    navigate("/");
  };

  return (
    <div className="container-fluid p-0">
      <div className="row g-0">
        <nav
          className={`col-auto sidebar text-dark ${isOpen ? "show" : "hide"}`}
          style={{
            minHeight: "100vh",
            width: isOpen ? "250px" : "0",
            transition: "width 0.3s ease",
            position: isMobile ? "fixed" : "relative",
            zIndex: 999,
            backgroundColor: "#fff",
            overflow: "hidden",
            borderRight: "1px solid #e0e0e0",
            display: "flex",
            flexDirection: "column",  
          }}
        >
          <div className="p-3" style={{ flex: 1, display: "flex", flexDirection: "column" }}>
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h3 className="m-0 border-bottom pb-3"  style={{ textAlign: "center", flexGrow: 1,fontFamily: 'Poppins' }}><img src="./prowess-logo.png" alt="Prowesserp Logo" height={40}/></h3>
              {isMobile && (
                <button className="btn btn-sm btn-outline-dark" onClick={toggleSidebar}>
                  &times;
                </button>
              )}
            </div>

            {isMobile && (
              <div className="dropdown text-center">
      <div
        className="d-flex align-items-center justify-content-center gap-2 fw-bold dropdown-toggle"
        role="button"
        id="userDropdown"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        <i className="bi bi-person-fill" style={{ fontSize: '1.5rem' }}></i>
        <span>{user}</span>
      </div>
      <ul className="dropdown-menu dropdown-menu-end text-center" aria-labelledby="userDropdown">
        <li>
          <button onClick={logoutFunction} style={styles.logoutButton}>
              <i className="bi bi-box-arrow-right" style={styles.logoutIcon}></i>
              Logout
            </button>
        </li>
      </ul>
    </div>
            
            )}
          



<div className="accordion" id="accordionExample" >
  {/* Optional: Hardcoded First Item */}
  {/* <div className="accordion-item">
    <h2 className="accordion-header" id="headingOne">
      <button
        className="accordion-button"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#collapseOne"
        aria-expanded="true"
        aria-controls="collapseOne"
      >
        Prowess ERP
      </button>
    </h2>
    <div
      id="collapseOne"
      className="accordion-collapse collapse show"
      aria-labelledby="headingOne"
      data-bs-parent="#accordionExample"
    >
      <div className="accordion-body" style={{ padding: "0" }}>
        <ul className="nav nav-pills flex-column pt-3" style={{ flexGrow: 1 }}>
          {topics.map((topic) => (
            <li className="nav-item" key={topic.id}>
              <button
                className={`nav-link text-dark ${
                  selectedTopic === topic.id ? "active bg-secondary text-white" : ""
                }`}
                style={styles.topicButton}
                onClick={() => {
                  setSelectedTopic(topic.id);
                  setSelectedDisplayName(topic.displayName);
                }}
              >
                {topic.icon && <span className="me-2">{topic.icon}</span>}
                {topic.displayName}
              </button>
            </li>
          ))}
        </ul>
      </div>
    </div>
  </div> */}
  

{parsedProducts.map((product, index) => (
  <div className="accordion-item mb-3" key={product.productId}>
    <h2 className="accordion-header" id={`heading-${product.productId}`}>
      <button
        className={`accordion-button ${index !== 0 ? 'collapsed' : ''} bg-light text-dark fw-semibold border-0 rounded-3`}
        type="button"
        data-bs-toggle="collapse"
        data-bs-target={`#collapse-${product.productId}`}
        aria-expanded={index === 0 ? 'true' : 'false'}
        aria-controls={`collapse-${product.productId}`}
        style={{
          backgroundColor: '#f1f1f1', 
          transition: 'background-color 0.3s ease',
        }}
        onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#e2e2e2'} 
        onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#f1f1f1'} 
      >
        {product.productName}
      </button>
    </h2>
    
    <div
      id={`collapse-${product.productId}`}
      className={`accordion-collapse collapse ${index === 0 ? 'show' : ''}`}
      aria-labelledby={`heading-${product.productId}`}
      data-bs-parent="#accordionExample"
    >
      
      <div className="accordion-body p-2" style={{ backgroundColor: "white", overflow: "hidden" }}>
        <ul className="nav nav-pills flex-column pt-2" style={{ flexGrow: 1 }}>
          {product.modules.map((topic) => (
            <li className="nav-item" key={topic.moduleId}>
              <button
                className={`nav-link text-dark ${selectedTopic === topic.moduleId ? "active bg-secondary text-white" : ""}`}
                style={styles.topicButton}
                onClick={() => {
                  setSelectedTopic(topic.moduleId);
                  setSelectedDisplayName(topic.moduleName);
                }}
              >
                
                  {/* <Layers className="text-blue-400" /> */}
                  <span
                    className="me-2"
                    dangerouslySetInnerHTML={{ __html: topic.moduleIcon }}
                  ></span> 
                {topic.moduleName}
              </button>
            </li>
          ))}
        </ul>
      </div>
    </div>
  </div>
))}

</div>

            {/* {isMobile && (
            <div style={styles.logoutButtonContainer}>
            <button onClick={logoutFunction} style={styles.logoutButton}>
              <i className="bi bi-box-arrow-right" style={styles.logoutIcon}></i>
              Logout
            </button>
          </div>
          )} */}
            
          </div>
        </nav>

        <div className="col" style={{ marginLeft: isMobile ? "0" : isOpen ? "0" : "0" }}>
          {isMobile && (
            <button className="btn btn-dark m-2" onClick={toggleSidebar} aria-label="Toggle sidebar">
              ☰
            </button>
          )}

        </div>
      </div>
    </div>
  );
};

const styles = {
  topicButton: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    padding: "0.75rem",
    border: "none",
    background: "none",
    textAlign: "left",
    fontSize: "1rem",
    color: "#555",
    cursor: "pointer",
    transition: "background-color 0.3s",
  },
  logoutButton: {
    width: "100%", 
    padding: "12px",
    border: "none",
    fontSize: "1rem",
    fontWeight: "bold",
    borderRadius: "8px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    color: "red",
    background: "transparent",
  },
  logoutIcon: {
    marginRight: "8px",
    fontSize: "1.2rem",
  },
  logoutButtonContainer: {
    borderTop: "1px solid #e0e0e0",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    bottom:'0',
    marginTop: "auto",
    padding: "10px",
  },
};

export default Sidebar;
